import { ValidationResult } from '../types/validation-result.mjs';

function descriptionValidator(productOption, hideDescriptionsProp) {
    const validationResults = new ValidationResult();
    // do not hide descriptions by default
    let hideDescriptions = false;
    if (hideDescriptionsProp === true) {
        hideDescriptions = true;
    }
    else {
        const optionDescriptionValidator = new OptionDescriptionValidator(productOption);
        const { result, violations } = optionDescriptionValidator.validateDescriptions();
        hideDescriptions = !result;
        Object.entries(violations).map(([choiceKey, choiceViolations]) => {
            choiceViolations.map((violation) => validationResults.addValidation(`Option value key ${choiceKey} failed description validation with code ${violation}`));
        });
    }
    return {
        hideDescriptions,
        messages: validationResults.messages,
    };
}
var DescriptionViolationCode;
(function (DescriptionViolationCode) {
    DescriptionViolationCode["EMPTY_DESCRIPTION"] = "EmptyDescription";
    DescriptionViolationCode["DESCRIPTION_CONTAINS_LINK"] = "DescriptionContainsLink";
    DescriptionViolationCode["DESCRIPTION_CONTAINS_MEDIA"] = "DescriptionContainsMedia";
    DescriptionViolationCode["DESCRIPTION_TOO_LONG_OR_TOO_SHORT"] = "DescriptionTooLongOrTooShort";
})(DescriptionViolationCode || (DescriptionViolationCode = {}));
class OptionDescriptionValidator {
    individualViolationCounter;
    validationResult;
    productOption;
    constructor(productOption) {
        this.productOption = productOption;
        this.validationResult = {};
        this.individualViolationCounter = Object.values(DescriptionViolationCode).reduce((result, violationCode) => {
            result[violationCode] = 0;
            return result;
        }, {});
    }
    validateDescriptions() {
        const result = this.getGroupValidationResults() && this.getIndividualValidationResults();
        return {
            result,
            violations: { ...this.validationResult },
        };
    }
    getGroupValidationResults() {
        const groupValidations = [this.descriptionTooLong];
        return groupValidations.every((validation) => validation.bind(this)());
    }
    getIndividualValidationResults() {
        return this.productOption.choices.every((choice) => this.validateIndividualDescription(choice));
    }
    validateIndividualDescription(productOptionListModel) {
        return (!this.descriptionContainsLink(productOptionListModel) &&
            !this.descriptionContainsMedia(productOptionListModel) &&
            !this.hasHappenedNthTime(() => !this.descriptionIsEmpty(productOptionListModel), DescriptionViolationCode.EMPTY_DESCRIPTION, 2));
    }
    hasHappenedNthTime(passPredicate, violationCode, numberOfTimes) {
        const result = passPredicate();
        if (!result && this.individualViolationCounter[violationCode] >= numberOfTimes) {
            return true;
        }
        return false;
    }
    descriptionTooLong() {
        const allKeyDescriptionPairs = (this.productOption.choices
            .filter((choice) => !this.descriptionIsEmpty(choice))
            .map((choice) => ({ key: choice.key, description: choice.description }))
            .filter((keyDescriptionPair) => !!keyDescriptionPair.description)
            .map((keyDescriptionPair) => {
            const cleanedDescription = this.cleanUpDescription(keyDescriptionPair.description || "");
            return { key: keyDescriptionPair.key, description: cleanedDescription };
        }) || []);
        const averageLength = this.calculateAverage(allKeyDescriptionPairs.map((keyDescriptionPair) => keyDescriptionPair.description.length));
        const result = allKeyDescriptionPairs.every(({ key, description }) => {
            if (description.length > 0.5 * averageLength && description.length < 1.5 * averageLength) {
                return true;
            }
            this.addDescriptionViolation(key, DescriptionViolationCode.DESCRIPTION_TOO_LONG_OR_TOO_SHORT);
            return false;
        });
        return result;
    }
    descriptionIsEmpty(productOptionListModel) {
        const { description, key } = productOptionListModel;
        if (!description) {
            this.addDescriptionViolation(key, DescriptionViolationCode.EMPTY_DESCRIPTION);
            return true;
        }
        const cleanedDescription = this.cleanUpDescription(description);
        if (!/\S/g.test(cleanedDescription)) {
            this.addDescriptionViolation(key, DescriptionViolationCode.EMPTY_DESCRIPTION);
            return true;
        }
        return false;
    }
    descriptionContainsLink(productOptionListModel) {
        const { description, key } = productOptionListModel;
        if (/<a>|<a (.|\n)*?>/g.test(description || "")) {
            this.addDescriptionViolation(key, DescriptionViolationCode.DESCRIPTION_CONTAINS_LINK);
            return true;
        }
        return false;
    }
    descriptionContainsMedia(productOptionListModel) {
        const { description, key } = productOptionListModel;
        if (/<(img|picture|video)>|<(img|picture|video) (.|\n)*?>/g.test(description || "")) {
            this.addDescriptionViolation(key, DescriptionViolationCode.DESCRIPTION_CONTAINS_MEDIA);
            return true;
        }
        return false;
    }
    addDescriptionViolation(optionChoiceKey, violation) {
        if (!this.validationResult[optionChoiceKey]) {
            this.validationResult[optionChoiceKey] = [];
        }
        if (!this.validationResult[optionChoiceKey].includes(violation)) {
            this.validationResult[optionChoiceKey].push(violation);
            this.individualViolationCounter[violation]++;
        }
    }
    /**
     * Remove html tags and html white space (nbsp) from input string
     * @param description input string
     * @returns cleaned up string
     */
    cleanUpDescription(description) {
        return description.replaceAll(/<(.|\n)*?>/g, "").replaceAll("&nbsp;", " ");
    }
    calculateAverage(array) {
        return array.reduce((total, current) => total + current, 0) / array.length;
    }
}

export { DescriptionViolationCode, OptionDescriptionValidator, descriptionValidator };
//# sourceMappingURL=description-validator.mjs.map
